import { createPersistentStorage } from "@/script/storage/storage-factory"
import * as api from "@/script/api"
import { parseJwt } from "@/script/helper"

const defaultState = {
	jwt: null,
	id: "",
	name: "",
	avatar: "",
	isContributor: false,
	isEditor: false,
}

export default createPersistentStorage(
	"tcf.user",
	defaultState,
	{
		setJwt(state, jwt) {
			state.jwt = jwt || null

			const jsonContent = parseJwt(jwt)

			state.id = jsonContent?.id ?? defaultState.id
			state.name = jsonContent?.name ?? defaultState.name
			state.avatar = jsonContent?.avatar ?? defaultState.avatar
			state.isContributor =
				jsonContent?.isContributor ?? defaultState.isContributor
			state.isEditor = jsonContent?.isEditor ?? defaultState.isEditor
		},
	},
	{
		async fetchUser({ state }) {
			if (state.jwt === null) {
				return
			}

			await api.getUser()
		},
		async invalidateUser({ commit }) {
			commit("setJwt", null)
		},
	},
	{
		token(state) {
			return state.jwt
		},
		isLoggedIn(state) {
			return state.jwt !== null && state.id !== ""
		},
	}
)
